module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAIKADAAQAAAABAAAAGAAAAAA915G0AAAAr0lEQVRIDWPcuO+I+u07D/d/+/5DkoGOgIuT47mqirwjs4m182V6Ww7y5+8/f3g/f/4azAKzvDg9jo7+Z2DonbmIAWQ3E11txWLZqANGQ4ClfsYjBhZWNoa9j19iSSK0Ezq09RHY8NEoGA2B0RAY8BBgXC7A8B+UIa1lJGiX6bGYfPTJC7DogIfAqANGQwCUCy4Dk6MOloRKD6HzTP9/M7gwMjJco4dtaHacB9rtCQCL5DKHptGpPQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flag-ru@2x.png
// module id = 519
// module chunks = 9